import Vue from 'vue';

Vue.directive('ga-event', {
	bind(el, binding) {
		const { eventCategory, eventAction, eventLabel, className, attributes, eventFeature } = binding.value;

		//Gắn class nếu có
		if (className) {
			el.classList.add(`ga-ibt-${className}`);
		}

		//Thêm các attribute bổ sung nếu có
		if (attributes && typeof attributes === 'object') {
			Object.keys(attributes).forEach(key => {
				el.setAttribute(`ga-ibt-${key}`, attributes[key]);
			});
		}

		//Khởi tạo dataLayer nếu chưa có
		window.dataLayer = window.dataLayer || [];

		//Xử lý sự kiện click
		el.addEventListener('click', event => {
			//Đảm bảo chỉ gửi sự kiện từ phần tử cha
			if (event.currentTarget === el) {
				try {
					//Thêm sự kiện khi người dùng click vào nút Kết nối
					dataLayer.push({
						event: `ga_ibt_${eventAction}`,
						event_category: `ga_ibt_category_${eventCategory}`,
						event_label: `ga_ibt_label_${eventLabel}`,
						event_feature: `ga_ibt_feature_${eventFeature}`,
						event_class: `ga_ibt_class_${className}`
					});
				} catch (error) {
					console.error('Error in GTM:', error);
				}
			}
		});
	}
});
